function minHeight(list, content) {
   var $panelContent = list.find('.list-filter > .panel > .panel-content');
   var height = 0;
   if ($panelContent.length > 0) {
      height = $panelContent.height();
   }

   content.css('min-height', height + 'px');
}

$('.list').each(function(_, element){
    var list = $(element);
    var hiddenInput = list.find('[name^="filter"]');
    var content = list.find('.list-content');
    var formSetter = list.find('a[data-form-name]');
    var minHeightHandler = function() {
        minHeight(list, content);
    };

    if(hiddenInput.attr('value') === 'open') {
        list.addClass('with-filter');
    }

    list.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend', minHeightHandler);
    $(document).on('layout-changed', minHeightHandler);
    $(document).on('load', function() {
        minHeight(list, content);
    });

    list.find('.list-filter > .panel').on('panel-on', function() {
        list.addClass('with-filter');
        hiddenInput.attr('value', 'open');
    }).on('panel-off', function() {
        list.removeClass('with-filter');
        hiddenInput.attr('value', 'closed');
    });

    formSetter.on('click', function(ev) {
        ev.preventDefault();

        var $setter = $(ev.currentTarget);
        var form = $('form[name="' + $setter.data('form') + '"]');

        form.find('[name="' + $setter.data('form-name') + '"]').val([$setter.data('form-value')]);
        form.submit();
    });

    list.find('.list-filter button[type=reset]').on('click', function(ev) {
        ev.preventDefault();

        var href = location.href;

        list.find('.list-filter input, .list-filter select, .list-filter textarea').each(function(_, inputEl){
            if(inputEl.name) {
                var start = href.indexOf(inputEl.name);

                if(start > -1) {
                    var newRef = href.substring(0, start);
                    var end = href.indexOf('&', start);

                    if(end > -1) {
                        newRef += href.substring(end + 1);
                    }

                    href = newRef;
                }
            }
        });

        if(href.lastIndexOf('?') === href.length - 1) {
            href = href.substr(0, href.length - 1);
        }

        var wrapper = $(ev.currentTarget).closest('.list-wrapper[id^="filters-anchor-"]');
        var anchorId = wrapper.attr('id');
        if (anchorId) {
            href += '#' + anchorId;
        }

        location.href = href;
    });
});

window.addEventListener('load', function () {
   const target = location.hash && document.getElementById(location.hash.slice(1));

   if (target) {
      const tabPanel = target.closest('[data-tab-content]');
      if (tabPanel && tabPanel.classList.contains('hidden')) {
         const tabId = tabPanel.getAttribute('id');
         const tabTrigger = document.querySelector(`[data-tab-target="#${tabId}"]`);

         if (tabTrigger) {
            tabTrigger.click();
         }
      }

      setTimeout(() => {
         target.scrollIntoView({ behavior: 'smooth' });
      }, 300);
   }
});
